/*
 * @Date         : 2021-07-30 15:52:44
 * @LastEditors: zhangxu
 * @LastEditTime: 2022-04-25 17:29:56
 * @FilePath: /daodao-biz-front/src/router/otherRoutes.ts
 */
import { RouteRecordRaw } from 'vue-router'
export const otherRoutes: Array<RouteRecordRaw> = [
  {
    path: '/growUpData/growUpData-detail',
    name: 'growUpData-detail',
    meta: {
      title: '成长方案库详情',
      keepAlive: false,
      requireAuth: true,
      routerKey: 'growUpData-detail',
      visible: true,
    },
    component: () => import(/* webpackChunkName: "recruit-diagnose" */ '@/views/diagnose-center/growUpData_detail.vue'),
  },
  {
    path: '/evaluation-quick-launch/create',
    name: 'evaluation-create-scene',
    meta: {
      title: '创建评估',
      keepAlive: false,
      requireAuth: true,
      routerKey: 'evaluation-quick-launch',
      visible: true,
      ignoreCrumbs: true,
    },
    component: () =>
      import(/* webpackChunkName: "evaluation-quick-launch" */ '@/views/diagnose-center/evaluation-create-scene.vue'),
  },
  {
    path: '/evaluation-diagnose-initiation-record/activity-detail',
    name: 'scene-activity-detail',
    meta: {
      title: '评估活动详情',
      keepAlive: false,
      requireAuth: true,
      routerKey: 'diagnose-initiation-record',
      visible: true,
    },
    component: () => import(/* webpackChunkName: "recruit-diagnose" */ '@/views/diagnose-center/activity-detail.vue'),
  },
  {
    path: '/diagnose-initiation-record/activity-detail',
    name: 'activity-detail',
    meta: {
      title: '评估活动详情',
      keepAlive: false,
      requireAuth: true,
      routerKey: 'diagnose-initiation-record',
      visible: true,
    },
    component: () => import(/* webpackChunkName: "recruit-diagnose" */ '@/views/diagnose-center/activity-detail.vue'),
  },
  {
    path: '/dashboard/todo',
    name: 'todo-index',
    meta: {
      title: '日程',
      keepAlive: false,
      requireAuth: true,
      routerKey: 'dashboard',
      visible: true,
      ignoreCrumbs: false,
    },
    component: () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/todoIndex.vue'),
  },
  {
    path: '/setting/role-setting',
    name: 'role-setting',
    meta: {
      title: '角色权限管理',
      keepAlive: false,
      requireAuth: true,
      routerKey: 'setting',
      visible: false,
      permissionId: [10000],
    },
    component: () => import(/* webpackChunkName: "setting" */ '@/views/role-setting/index.vue'),
  },
  {
    path: '/setting/role-info/:type',
    name: 'role-info',
    meta: {
      title: '角色权限配置',
      keepAlive: false,
      requireAuth: true,
      routerKey: 'setting',
      visible: false,
      permissionId: [10000],
    },
    component: () => import(/* webpackChunkName: "setting" */ '@/views/role-setting/RoleInfo.vue'),
  },
  {
    path: '/setting/account-info/:type',
    name: 'account-info',
    meta: {
      title: '手机号配置',
      keepAlive: false,
      requireAuth: true,
      routerKey: 'setting',
      visible: false,
    },
    component: () => import(/* webpackChunkName: "setting" */ '@/views/role-setting/AccountInfo.vue'),
  },
  {
    path: '/open-seas/userInfo',
    name: 'open-seas-archives-userInfo',
    meta: {
      title: '客户档案',
      keepAlive: false,
      requireAuth: true,
      routerKey: 'open-seas',
      visible: true,
    },
    component: () => import(/* webpackChunkName: "archives" */ '@/views/growth-center/growth-archives/user-info.vue'),
  },
  {
    path: '/archives/userInfo',
    name: 'archives-userInfo',
    meta: {
      title: '客户档案',
      keepAlive: false,
      requireAuth: true,
      routerKey: 'archives',
      visible: true,
    },
    component: () => import(/* webpackChunkName: "archives" */ '@/views/growth-center/growth-archives/user-info.vue'),
  },
  {
    path: '/archives/operation_log',
    name: 'archives-operation_log',
    meta: {
      title: '操作日志',
      keepAlive: false,
      requireAuth: true,
      routerKey: 'archives',
      visible: true,
    },
    component: () =>
      import(/* webpackChunkName: "archives" */ '@/views/growth-center/growth-archives/operation_log.vue'),
  },

  {
    path: '/archives/genJIn',
    name: 'archives-genJIn',
    meta: {
      title: '跟进记录',
      keepAlive: false,
      requireAuth: true,
      routerKey: 'archives',
      visible: true,
    },
    component: () => import(/* webpackChunkName: "archives" */ '@/views/growth-center/growth-archives/genJIn.vue'),
  },
  {
    path: '/open-seas/detail',
    name: 'open-seas-archives-detail',
    meta: {
      title: '档案详情',
      keepAlive: false,
      requireAuth: true,
      routerKey: 'open-seas',
      visible: true,
    },
    component: () =>
      import(/* webpackChunkName: "archives" */ '@/views/growth-center/growth-archives/archives-detail.vue'),
  },
  // ai学习力版档案详情
  {
    path: '/open-seas/ability-archives',
    name: 'study-power-archives',
    meta: {
      title: '档案详情',
      keepAlive: false,
      requireAuth: true,
      routerKey: 'open-seas',
      visible: true,
      hiddenTopper: true,
    },
    component: () => import(/* webpackChunkName: "archives" */ '@/views/growth-center/ability-archives/index.vue'),
  },
  {
    path: '/archives/detail',
    name: 'archives-detail',
    meta: {
      title: '用户详情',
      keepAlive: false,
      requireAuth: true,
      routerKey: 'archives',
      visible: true,
    },
    component: () =>
      import(/* webpackChunkName: "archives" */ '@/views/growth-center/growth-archives/archives-detail.vue'),
  },
  {
    path: '/archives/detail/tags',
    name: 'archives-detail-tags',
    meta: {
      title: '用户状况',
      keepAlive: false,
      requireAuth: true,
      routerKey: 'archives',
      visible: true,
    },
    component: () =>
      import(/* webpackChunkName: "archives" */ '@/views/growth-center/growth-archives/archives-detail-tags.vue'),
  },
  {
    path: '/diagnose-library/diagnose-detail',
    name: 'diagnose-detail',
    meta: {
      title: '评估详情',
      keepAlive: false,
      requireAuth: true,
      routerKey: 'diagnose-library',
      visible: true,
    },
    component: () => import(/* webpackChunkName: "diagnose-center" */ '@/views/diagnose-center/diagnose-details.vue'),
  },

  {
    path: '/recruit/report',
    name: 'report',
    meta: {
      title: '流体智力报告',
      keepAlive: false,
      requireAuth: true,
      routerKey: 'recruit',
      visible: true,
    },
    component: () => import(/* webpackChunkName: "recruit-diagnose" */ '@/views/report/index.vue'),
  },
  {
    path: '/assess/tec-result',
    name: 'tec-result',
    meta: {
      title: '人才评估报告',
      keepAlive: false,
      requireAuth: true,
      routerKey: 'assess',
      visible: true,
    },
    component: () => import(/* webpackChunkName: "assess" */ '@/views/tec-result/index.vue'),
  },
  {
    path: '/customers/assess',
    name: 'customers-assess',
    meta: {
      title: '升学方向测评',
      keepAlive: false,
      requireAuth: true,
      routerKey: 'customers',
      visible: true,
      ignoreCrumbs: true,
    },
    component: () => import(/* webpackChunkName: "further" */ '@/views/further/public/assess.vue'),
  },
  {
    path: '/service/workbench',
    name: 'service-workbench',
    meta: {
      title: '升学填报',
      keepAlive: false,
      requireAuth: true,
      routerKey: 'service',
      ignoreCrumbs: true,
    },
    component: () => import(/* webpackChunkName: "further" */ '@/views/further/workbench/index.vue'),
  },
  {
    path: '/open-seas/logs',
    name: 'open-seas-logs',
    meta: {
      title: '公海日志',
      keepAlive: false,
      requireAuth: true,
      routerKey: 'open-seas',
      visible: true,
      ignoreCrumbs: false,
    },
    component: () => import(/* webpackChunkName: "growthCenter" */ '@/views/growth-center/open-seas/logs.vue'),
  },
  {
    path: '/stu-info',
    name: 'stu-info',
    meta: {
      title: '个人信息',
      keepAlive: false,
      requireAuth: true,
      routerKey: 'stu-info',
      visible: true,
    },
    component: () => import(/* webpackChunkName: "archives" */ '@/views/setting/StuInfo.vue'),
  },
  {
    path: '/receive-code-detail',
    name: 'receive-code-detail',
    meta: {
      title: '使用详情',
      keepAlive: false,
      requireAuth: true,
      routerKey: 'receive-code-detail',
      visible: true,
    },
    component: () => import(/* webpackChunkName: "archives" */ '@/views/diagnose-center/receive-code-detail.vue'),
  },
]
// export const otherRoutes: Array<RouteRecordRaw> = [
//
//   // 微服务这里的路由需要在这里列出来，不能使用path的正则用法/*，否则会被router.beforeEach拦截，
//   {
//     name: 'react',
//     path: '/react',
//     meta: { isMicrApp: true },
//     component: () => import(/* webpackChunkName: "layout" */ '@/views/widget/MicroBlank.vue'),
//   },
//   {
//     name: '/selectsubject/subjectSearchSchool',
//     path: '/app-react/selectsubject/subjectSearchSchool',
//     meta: { isMicrApp: true, title: '根据科目选学校' },
//     component: () => import(/* webpackChunkName: "layout" */ '@/views/widget/MicroBlank.vue'),
//   },
//   {
//     name: '/selectsubject/majorSearchSchool',
//     path: '/app-react/selectsubject/majorSearchSchool',
//     meta: { isMicrApp: true, title: '根据专业选学校' },
//     component: () => import(/* webpackChunkName: "layout" */ '@/views/widget/MicroBlank.vue'),
//   },
//   {
//     name: '/selectsubject/detail',
//     path: '/app-react/selectsubject/detail',
//     meta: { isMicrApp: true, title: '选科详情' },
//     component: () => import(/* webpackChunkName: "layout" */ '@/views/widget/MicroBlank.vue'),
//   },
// ]
